// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150136/js/" + chunkId + "." + {"44":"9793289a","225":"34825934","481":"869a0709","486":"5c93012d","770":"732f79cc"}[chunkId] + ".0.8809073299490452.chunk.js";
};